import { NavigateFunction } from 'react-router';

import { IFormattedSearch } from 'components/Header';
import { navigateToFrame } from 'components/Header/components/SearchBar/utils/navigateToFrame';

export const handleSelection = (navigate: NavigateFunction, option: IFormattedSearch) => {
  navigateToFrame(navigate, option.id);
};
